import { makeStyles } from "@mui/styles"

import { Palette } from "../../../lib/_private.js"

export const useControlOverrides = makeStyles(({ withPalette }) => ({
  root: ({ color, disabled }) => ({
    "&.MuiCheckbox-root": {
      "&[class*='Mui-checked']": {
        color: withPalette(color, Palette.isSecondary(color) ? "contrastText" : "main"),
      },
      color: disabled ? "#bdbdbd" : "#757575",
    },
  }),
}))

export const useLabelOverrides = makeStyles(({ typography }) => ({
  label: ({ disabled }) => ({
    "&.MuiTypography-root": {
      color: disabled ? "#bdbdbd" : typography.color,
      fontSize: typography.pxToRem(14),
      fontWeight: 700,
    },
    alignItems: "center",
    display: "flex",
  }),

  root: {
    alignItems: "stretch",
    marginBottom: 0,
    width: "fit-content",
  },
}))
